var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColorTimeline = function SvgColorTimeline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M.5.67v14a1 1 0 0 0 1 1h14"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 2,
    x: 2.5,
    y: 11.67,
    stroke: "#000",
    rx: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 2,
    x: 6.5,
    y: 6.67,
    stroke: "#000",
    rx: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 2,
    x: 10.5,
    y: 1.67,
    stroke: "#000",
    rx: 0.5
  })));
};
export default SvgColorTimeline;